import * as Sentry from '@sentry/react'
import { IUserExtended } from '../../types/data-types'

export class UserStore {
  constructor(public data: IUserExtended) {
    Sentry.setUser({ email: data?.email, id: `${data?.userId}` })
  }

  public isAdmin = () => !!this.data.role.systemAdmin
  public isWorkshopAdmin = workshopId =>
    this.data.role.workshopAccess.filter(user => user.workshopId == workshopId && user.role == 'Admin').length > 0
  public isWorkshopResource = workshopId =>
    this.data.role.workshopAccess.filter(user => user.workshopId == workshopId && user.role == 'Regular').length > 0
  public isWorkshopSystem = workshopId =>
    this.data.role.workshopAccess.filter(user => user.workshopId == workshopId && user.role == 'System').length > 0
  public isReadonly = clientId => {
    return clientId !== null && this.data.role.clientBoatRoles.find(element => element.clientId === clientId)?.readonly
  }

  public isAdminOrInAccessGroup = (boatId = null, clientId = null) => {
    const isPartOfAccessGroup =
      clientId == null
        ? this.data.role.clientBoatRoles?.length > 0 &&
          this.data.role.clientBoatRoles?.filter(element => !element.readonly)?.length > 0
        : !this.data.role.clientBoatRoles.find(element => element.clientId === clientId)?.readonly

    if (boatId === null) {
      return this.isAdmin() || isPartOfAccessGroup
    } else {
      let hasAccessToBoat = false
      for (let i = 0; i < this.data.role.clientBoatRoles.length; i++) {
        if (
          this.data.role.clientBoatRoles[i].boatsWithAccess.indexOf(boatId) > -1 &&
          !this.data.role.clientBoatRoles[i].readonly
        ) {
          hasAccessToBoat = true
        }
      }
      if (this.data.role.individualBoatsAccess.indexOf(parseInt(boatId)) > -1) {
        hasAccessToBoat = true
      }

      return this.isAdmin() || isPartOfAccessGroup || hasAccessToBoat
    }
  }
}
